import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import marsLogo from "../../assets/img/Mars-icon-Navbar.png";
import marsLogoText from "../../assets/img/Mars-Navbar.png";
import Logout from "../auth/Logout";
import "./TopNavBar.scss";
import { FaCogs } from "react-icons/fa";
import Getusers from "../auth/Getusers";
import { Avatar, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { Link, useNavigate } from 'react-router-dom';
import { LogOut, Settings, Home, Users, FileText, User, OptionIcon } from 'lucide-react';

const drawerWidth = 300;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${300}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  ...(!open && {
    marginLeft: drawerWidth,
    width: `calc(100%)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Topnavbar = (props) => {
  // const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [openDialog, setopenDialog] = useState(false);
  // const [openDialogq1, setopenDialog1] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);
  const settingsMenuOpen = Boolean(settingsAnchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };



  const handleSettingsClick = (event) => {
    setSettingsAnchorEl(event.currentTarget);
  };

  const handleSettingsClose = () => {
    setSettingsAnchorEl(null);
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <AppBar
          position="fixed"
          style={{ backgroundColor: "white", boxShadow: "none", zIndex: "1" }}
          open={props.open}
          className="topNavBar"
        >
          <Toolbar
            className="navBarStyle"
            style={{
              justifyContent: "space-between",
              padding: "20px 60px",
              alignItems: "center",
              height: "80px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                color: "#253978",
                fontSize: "28px",
                fontWeight: "700",
                width: "100%",
                textAlign: "left",
              }}
              noWrap
              component="div"
              className="navBarStyleColor"
            >
              <div className="navbar-container">
                <div className="logo-container">
                  <img src={marsLogo} alt="MARS LOGO" />
                  <img src={marsLogoText} alt="MARS LOGO TEXT" />
                </div>

                <h3 className="navbar-heading">
                  QMS 2nd Party Audit Web Portal
                </h3>

                <div className="right-side-container">

                  <div>
                    <a style={{ color: "white" }} href="/">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="36"
                        height="36"
                        viewBox="0 0 36 36"
                        fill="none"
                      >
                        <path
                          d="M14.9999 28.5001V21.0001H20.9999V28.5001C20.9999 29.3251 21.6749 30.0001 22.4999 30.0001H26.9999C27.8249 30.0001 28.4999 29.3251 28.4999 28.5001V18.0001H31.0499C31.7399 18.0001 32.0699 17.1451 31.5449 16.6951L19.0049 5.40008C18.4349 4.89008 17.5649 4.89008 16.9949 5.40008L4.4549 16.6951C3.9449 17.1451 4.2599 18.0001 4.9499 18.0001H7.4999V28.5001C7.4999 29.3251 8.1749 30.0001 8.9999 30.0001H13.4999C14.3249 30.0001 14.9999 29.3251 14.9999 28.5001Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>


                  {(props.Role === "Super Admin") && (
                    <div>
                      <IconButton onClick={handleSettingsClick}>
                        <FaCogs style={{ fontSize: "34px", color: "white" }} />
                      </IconButton>
                    </div>
                  )}

                    {(props.Role === "CB Admin" || props.Role === "CB Admin (Tech Reviewer)") && (
                    <div>
                      <Link style={{ color: "white" }} to="/admin/membercontrol">
                        <FaCogs style={{ fontSize: "34px" }} />
                      </Link>
                    </div>
                  )}



                  <div style={{ display: "flex" }}>



                    <div className="info-container">
                      <div className="main-info">
                        <p>
                          <Getusers name={true} />
                        </p>
                        <p className="info-profile">{props.Role === "CB Admin" ? 'CB Admin (Lead Auditor)' : props.Role}</p>
                      </div>

                    </div>

                    <Tooltip title="Account settings">

                      <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                      >
                        <Avatar sx={{ width: 52, height: 52, background: "white", color: "#0000a0", fontSize: "24px" }}>
                          <Getusers trim={true} />
                        </Avatar>
                      </IconButton>
                    </Tooltip>
                  </div>

                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    slotProps={{
                      paper: {
                        elevation: 0,
                        sx: {
                          overflow: 'visible',
                          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                          mt: 1.5,
                          '& .MuiAvatar-root': {
                            width: 22,
                            height: 22,
                            ml: -0.5,
                            mr: 1,
                          },
                          '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                          },
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem onClick={handleClose}>
                      <div onClick={() => {
                        setopenDialog(true);
                      }}
                        style={{ cursor: "pointer", display: "flex", gap: "10px", alignContent: "center", alignItems: "center" }}>

                        <span><svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                        >
                          <path
                            d="M5.83333 5.83333H12.8333C13.475 5.83333 14 5.30833 14 4.66667C14 4.025 13.475 3.5 12.8333 3.5H5.83333C4.55 3.5 3.5 4.55 3.5 5.83333V22.1667C3.5 23.45 4.55 24.5 5.83333 24.5H12.8333C13.475 24.5 14 23.975 14 23.3333C14 22.6917 13.475 22.1667 12.8333 22.1667H5.83333V5.83333Z"
                            fill="#0000a0"
                          />
                          <path
                            d="M24.0917 13.592L20.8367 10.337C20.7555 10.2536 20.6514 10.1964 20.5375 10.1725C20.4236 10.1487 20.3053 10.1594 20.1975 10.2033C20.0898 10.2471 19.9975 10.3221 19.9327 10.4187C19.8678 10.5152 19.8332 10.629 19.8333 10.7453V12.8336H11.6667C11.025 12.8336 10.5 13.3586 10.5 14.0003C10.5 14.642 11.025 15.167 11.6667 15.167H19.8333V17.2553C19.8333 17.7803 20.4633 18.037 20.825 17.6636L24.08 14.4086C24.3133 14.187 24.3133 13.8136 24.0917 13.592Z"
                            fill="#0000a0"
                          />
                        </svg></span>

                        <span>Logout</span>

                      </div>

                    </MenuItem>


                  </Menu>


                  <Menu
                    anchorEl={settingsAnchorEl}
                    open={settingsMenuOpen}
                    onClose={handleSettingsClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    <MenuItem onClick={() => {
                      handleSettingsClose();
                      navigate('/admin/membercontrol'); // or use history.push if not using React Router v6+
                    }}>
                     <span className="flex gap-2"><span> <Users style={{width:"15px"}} /></span>
                     <span> User Management</span></span>
                    </MenuItem>
                    <MenuItem onClick={() => {
                      handleSettingsClose();
                      navigate('/admin/questions'); // or use history.push if not using React Router v6+
                    }}>
                        <span className="flex gap-2"><span> <FileText  style={{width:"15px"}} /></span>
                      <span> Master Prompt</span></span>
                    </MenuItem>
                    <MenuItem onClick={() => {
                      handleSettingsClose();
                      navigate('/admin/options'); // or use history.push if not using React Router v6+

                      // Add your logic or route/admin/options
                    }}>
                       <span className="flex gap-2"><span> <OptionIcon  style={{width:"15px"}} /></span>
                       <span> Options Prompt</span></span>
                    </MenuItem>
                  </Menu>



                </div>
              </div>
              <Logout setopenDialog={setopenDialog} openDialog={openDialog} />
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};

export default Topnavbar;
